import React, { useState } from "react";
import { useTranslate } from "../../service/translation";
import {
    Box, Button,
    ButtonGroup,
    Drawer, makeStyles,
} from "@material-ui/core";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import {TopicList} from "../topic";
import CloseIconButton from "./CloseIconButton";
import {FiltersContext,appDefaultFilters} from "../../service/filters";
import classNames from "classnames";


const useStyles = makeStyles(theme => ({
    topicsContainer: {
        padding: theme.spacing(2, 1.5, 7),
    },
    topicsTitle: {
        /*pointerEvents: "none",*/
    },
    closeButton: {
        position: "absolute",
        right: 6,
        top: 14,
        zIndex: 1,
        '& svg':{
            width: 20,
            height: 20,
            color:  theme.palette.type === "light" ? theme.palette.text.hint : theme.palette.text.hint,
        }
    },
    bottomButtonsContainer: {
        position: "fixed",
        width: "100%",
        bottom: 0,
        '& button':{
            width: "100%",
            borderRadius: "0 !important",
            fontSize: "14px",
        },
    },
    outlinedButton:{
        '&.MuiButton-root': {
            borderColor: theme.palette.type === "light" ? '#CCC' : theme.palette.text.hint,
            '&:hover': {
                backgroundColor: theme.palette.type === "light" ? 'white' : theme.palette.background.paper,
            },
        },
        fontWeight: 400,
        color: theme.palette.type === "light" ? theme.palette.text.hint : theme.palette.text.hint,
        backgroundColor: theme.palette.type === "light" ? theme.palette.background.paper : theme.palette.background.paper,
    },
    active:{
        "& .MuiBottomNavigationAction-label": {
            position: "relative",
            "&:before": {
                position: "absolute",
                top: 0,
                left: "100%",
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                content: "''",
                backgroundColor: theme.palette.type === "light" ? theme.palette.primary.main : theme.palette.secondary.main,
            },
        },
    },
}));

export default function ToggleFilterBottomNavButton() {
    const classes = useStyles();
    const translate = useTranslate();
    const [open, setOpen] = useState(false);
    const [filters,setFilters] = React.useContext(FiltersContext);
    const [buttonClasses,setButtonClasses] = React.useState<any[]>( []);
    const handleToggle = () => setOpen(!open);

    const handleClean = () => {
        setFilters({
            ...filters,
            crossActions:{
                ...filters.crossActions,
                clearTopics: true
            }
        });

    };

    React.useEffect(() => {
        if(filters.activeTopics.length > 0 )setButtonClasses([classes.active]);
        else {setButtonClasses([]);}

    },[filters.activeTopics]);

    const handleApply = () => {
        setOpen(false);
    };

    return (
        <>
            <BottomNavigationAction showLabel={true} onClick={handleToggle} label={translate("newshub.bottomBar.topics")} className={classNames(...buttonClasses)} icon={<BookmarkIcon />} />
            <Drawer
                variant="temporary"
                anchor={"bottom"}
                open={open}
            >
                <CloseIconButton onClick={handleToggle} className={classes.closeButton} />
                <Box className={classes.topicsContainer}>
                    <TopicList justifyContent="left" title={translate("topic.message.title")} />
                </Box>
                <ButtonGroup disableElevation variant="contained" color="primary" className={classes.bottomButtonsContainer}>
                    <Button onClick={handleClean} variant={"outlined"} className={classes.outlinedButton}>{translate("newshub.action.clearAll")}</Button>
                    <Button onClick={handleApply} >{translate("newshub.action.apply")}</Button>
                </ButtonGroup>
            </Drawer>
        </>
    );
};

